import { Component, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent {
  loadingText: string = 'Loading';
  isArabic: boolean = false;

  constructor(
    public loader: LoaderService,
    private translateService: TranslateService
  ) {
    this.updateLoadingText();
    this.translateService.onLangChange.subscribe(() => {
      this.updateLoadingText();
    });
  }

  private updateLoadingText() {
    const currentLang = this.translateService.currentLang || localStorage.getItem('lang') || 'ar';
    this.isArabic = currentLang === 'ar';
    this.loadingText = this.isArabic ? 'يرجى الانتظار' : 'Loading';
  }

  get loadingLetters(): string[] {
    return this.loadingText.split('');
  }
}
